// Supabase configuration
// Note: Environment variables are validated at app startup in main.tsx
// SECURITY: Service role key is NEVER included in client-side code

function getSupabaseConfig() {
  const url = import.meta.env.VITE_SUPABASE_URL || ''
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''
  
  // Return config with empty values if missing
  // Validation is handled in main.tsx before app starts
  return {
    url: url as string,
    anonKey: anonKey as string,
    defaultOrgId: '00000000-0000-0000-0000-000000000001',
    localUrl: 'http://127.0.0.1:54321'
  }
}

export const SUPABASE_CONFIG = getSupabaseConfig()

export function validateSupabaseConfig() {
  if (!SUPABASE_CONFIG.url || !SUPABASE_CONFIG.anonKey) {
    throw new Error('Supabase configuration is incomplete.')
  }
}
